import { useEffect } from "react";
import { useCurrencyStore } from "../stores/useCurrencyStore";
import { useIndicativeRateStore } from "../stores/useIndicativeRateStore";
import { useOrdersStore } from "../stores/useOrderStore";
import { usePaymentLinkStore } from "../stores/usePaymentLinkStore";
import { useWebhookStore } from "../stores/useWebhookStore";
// import { useUserStore } from "../stores/useUserStore";


export const usePreloadData = () => {
  const { loadCurrencies, getWalletSupportedCurrencies } = useCurrencyStore();
  const { fetchRates } = useIndicativeRateStore();
  const { loadOrders } = useOrdersStore();
  const { loadPaymentLinks } = usePaymentLinkStore();
  // const { loadUser} = useUserStore();
  const { loadWebhooks } = useWebhookStore();

  useEffect(() => {

    // ---- preload user
    //loadUser();

    // ---- preload currencies
    loadCurrencies();
    getWalletSupportedCurrencies();

    // ---- preload indicative rates
    fetchRates();

    // ---- preload orders
    loadOrders();

    // ---- preload payment links
    loadPaymentLinks();

    // ---- preload webhooks
    loadWebhooks();

    

  }, [
    // loadUser,   
    loadCurrencies,
    getWalletSupportedCurrencies,
    fetchRates,
    loadOrders,
    loadPaymentLinks,
    loadWebhooks
  ]);
};
